<template>
  <b-row>
    <b-col>
      <b-row class="mb-3 mt-3" v-if="listingLoaded">
        <b-col class="text-left" v-for=" (suity,id) in listing.techDet.suitable" :key="id">
          <md-list>
            <md-list-item>
              <md-icon>{{getRuleIcon(suity)}}</md-icon>
              <div class="md-list-item-text">
                <span>{{getRule(suity)}}</span>
              </div>
            </md-list-item>
          </md-list>
        </b-col>
      </b-row>
      <b-row v-else style="margin:0 auto">
        <div class="loader-rolling-local"></div>
      </b-row>
    </b-col>
  </b-row>
</template>
<script>
import { mapGetters } from "vuex";

  const lists = require("@/lists.js");
  export default {
    props: {
      listing:{
        type: Object,
        required: true
      }
    },
    data: function () {
      return {
      }
    },
    computed: {
    ...mapGetters("internationalizationModule", ["i18n_local"]),

      listingLoaded(){
        if(this.listing.techDet && this.listing.techDet.suitable) return true
        else return false
      }
    },
    created() {
    },
    methods: {
      getRule(value){
        for(let suity of lists.suitableList){
          if (suity.value == value) return this.i18n_local[suity.value]
        }
        return ''
      },
      getRuleIcon(value){
        if(value=="events") return "event"
        if(value=="smoking") return "smoking_rooms"
        if(value=="disabFND") return "accessible"
        if(value=="pets") return "pets"
        if(value=="familyFND") return "child_friendly"
      },
      notEmpty(content){
        if(Array.isArray(content)) return content.length > 0
        else if(content) return true
        else return false
      }
    }
  };
</script>
<style scoped>
  @import '../../assets/styles/global.css';
  @import '../../assets/styles/listing-preview.css';

</style>



// WEBPACK FOOTER //
// src/components/listingComponents/propertyRules.vue